import React, { useEffect } from 'react';
import { Grid, Segment, Header } from 'semantic-ui-react';

import ArchivedReportsTable from './ArchivedReportsTable';
import BulkActionsProvider from 'shared/context/BulkActionsProvider';

import './index.scss';
import ArchivedRecordsProvider from 'shared/context/ArchivedRecordsProvider';
import { useDispatch, useSelector } from 'react-redux';
import contactActions from "actions/contact"
const StatCard = ({ title, value }) => (
    <div className='ArchivedReports__statCard'>
        <Header
            color='primary'
            className='ArchivedReports__statTitle'
        >
            {title}
        </Header>

        <Header as='h4'>
            {value}
        </Header>
    </div>
);

const ArchivedReports = () => {
    const { counts, isReading } = useSelector((state) => state.archive);
    const { isReadingRecordsLimits} = useSelector(state => state.contact)
    const dispatch = useDispatch();
    const productPermissions = useSelector(
        (state) => state.subscription.productPermissions
    );
    useEffect(() => {
        dispatch(contactActions.getRecordsLimits());
    }, [dispatch]);
    return (
        <Grid className='ArchivedReports'>
            <Grid.Row>
                <Grid.Column width={5}>
                    <Segment className='ArchivedReports__stats' loading={isReading || isReadingRecordsLimits}>
                        <StatCard
                            title="Total Records"
                            value={`${counts?.total_count || 0}/${productPermissions?.unique?.records || 0}`}
                        />

                        <StatCard
                            title="Archived Records"
                            value={counts?.total_archived_count || 0}
                        />
                    </Segment>
                </Grid.Column>
            </Grid.Row>

            <Grid.Row>
                <Grid.Column width={16}>
                    <ArchivedReportsTable />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

const ArchivedReportsPage = () => (
    <BulkActionsProvider>
        <ArchivedRecordsProvider>
            <ArchivedReports />
        </ArchivedRecordsProvider>
    </BulkActionsProvider>
);

export default ArchivedReportsPage;